import _extends from "babel-runtime/helpers/extends";
import React from "react";

import { RsIcon } from "@rosetta/react-common-ui";

import styles from "./SREIconStyles";

var mapping = {
  mic: styles.Microphone,
  micActive: styles.MicrophoneActive,
  help: styles.Help,
  VoiceTypeFemaleActiveIcon: styles.VoiceTypeFemaleActiveIcon,
  VoiceTypeChildActiveIcon: styles.VoiceTypeChildActiveIcon,
  VoiceTypeMaleActiveIcon: styles.VoiceTypeMaleActiveIcon,
  VoiceTypeFemaleInactiveIcon: styles.VoiceTypeFemaleInactiveIcon,
  VoiceTypeChildInactiveIcon: styles.VoiceTypeChildInactiveIcon,
  VoiceTypeMaleInactiveIcon: styles.VoiceTypeMaleInactiveIcon
};

export var SREIcon = function SREIcon(props) {
  return React.createElement(RsIcon, _extends({ useStyles: true, mapping: mapping }, props));
};

export default SREIcon;